import ct from "class-types.macro";
import React, { Suspense } from "react";
import useIsMounted from "~/common/useIsMounted";

import(
  /* webpackChunkName: "LimitedSaleStockNoticeTooltip" */ "./Styles/tippy.css"
);

const Tippy = React.lazy(() => import("@tippyjs/react"));

interface Props {
  saleStockLimit: number;
  saleStockAvailable: number;
  className?: ClassTypes | undefined;
}

const LimitedSaleStockNotice = ({
  saleStockLimit,
  saleStockAvailable,
  className = ct("text-center"),
}: Props) => {
  const isMounted = useIsMounted();

  return (
    <div
      className={`${ct(
        "font-semibold",
        "text-xs",
        "-mb-4",
        "text-red-500",
        className
      )}`}
      data-testid="LimitedSaleStockNotice"
    >
      {saleStockAvailable / saleStockLimit > 0.5
        ? "Limited Supply!"
        : `Only ${saleStockAvailable} Left!`}
      <>
        {isMounted && (
          <Suspense fallback={null}>
            <Tippy content="While Supplies Last.">
              <span
                style={{
                  pointerEvents: "all",
                }}
                className={ct("cursor-pointer")}
                data-testid="LimitedSaleStockNoticeTooltipTrigger"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-3 w-3"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  style={{ marginBottom: -1 }}
                >
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                    clipRule="evenodd"
                  />
                </svg>
              </span>
            </Tippy>
          </Suspense>
        )}
      </>
    </div>
  );
};

export default LimitedSaleStockNotice;
